// removed by extract-text-webpack-plugin
module.exports = {"header":"_31GWEaAdAw1axkUK","logoWrapper":"UaYrOieoz4Q7gEFp","logo":"iHcB7xUIkfRhrsaj","otherUser":"_1MFZ6Xdf-VvVYd6_","userName":"_2tsCmeXIS8fULKyi","right":"_2Z2f4PyacXGgF0iE","emptyProjectsListCaption":"FvBQaugjlDYBoMSe","startNewProject":"_31gPEotFaw1Q7Ura"};


//////////////////
// WEBPACK FOOTER
// ./app/components/User/UserPage.pcss
// module id = 513
// module chunks = 1